export default __webpack_public_path__ + "static/media/heavy-duty-box.543d6f0e.png";